<template>
  <div class="grid-wrap">
		<div class="grid-row">
			<article class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__bottom">
				
				<h1 class="alpha push__bottom push__top--double">{{title}}</h1>
				<p class="push__bottom">{{message}}</p>
				<div class="push__bottom">
					<Button :text="buttonText" url="/" variant="primary" isStart="true"/>
				</div>

			</article>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Timeout',
	data() {
		return {
			title: "You'll need to start again",
			message: "You've been timed out as you stopped using the service for 20 minutes.",
			buttonText: "Start again",
		}
	}
}
</script>